export default __webpack_public_path__ + "static/media/data_setting_3.f20bf964.png";